<img alt="logo" class="max-w-[300px]" [src]="secondaryLogo" />
<button class="my-8" extended form="login-form" mat-fab type="submit" (click)="onSubmit()">{{
  `${i18nScope}.LOGIN.BUTTON.LOGIN` | transloco
}}</button>
<szg-core-auth-ui-footer />
